<div class="sidetooltip fixed-closure-mobile" *ngIf="show" [ngClass]="extraClasses" >
    <div class="container d-flex flex-column flex-nowrap" *ngIf="show && showSidebar" [@inOutAnimation] (@inOutAnimation.done)="animationDone($event)">
        <div class="content-container lateral-container">
          <ng-content></ng-content>
        </div>
    </div>
</div>
